module.exports = __webpack_public_path__ + "img/file-89.91fde20c.png";